var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-containerv",on:{"mouseleave":function($event){return _vm.hoverFn(_vm.prevHovered, true)}}},_vm._l((_vm.times.filter(data =>  data.wOrm === _vm.workOrMeet || data.wOrm === 'both')),function(time){return _c('div',{key:time.value,class:{
      'grid-itemv': true,
      'is-beginning': time.isStart,
      'is-end': time.isEnd,
      'is-between': _vm.checkIfBetween(time),
    },on:{"mouseover":function($event){return _vm.hoverFn(time)},"click":function($event){return _vm.selectTime(time)}}},[_vm._v(" "+_vm._s(time.value)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }